module.exports = __webpack_public_path__ + "static/media/disc_conflict_sl_results.11e2d924.png";